import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/articles';

export default function Hero() {
  const leader = hotArticles[0];

  return (
    <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=Split%20screen%20cinematic%20composition%20of%20a%20bright%20glowing%20stage%20on%20the%20left%20with%20warm%20amber%20spotlights%20and%20a%20dim%20empty%20backstage%20corridor%20on%20the%20right%20with%20cool%20teal%20light%2C%20strong%20visual%20contrast%20between%20two%20worlds%2C%20moody%20atmosphere%2C%20film%20grain%2C%20no%20people%20visible%2C%20editorial%20photography%20abstract&width=1600&height=900&seq=contrast-hero-stage&orientation=landscape"
        alt="舞台灯光与后台通道左右分割形成的反差画面"
        title="反差现场 - 镜头前后两副面孔"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/40 to-black/60" />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/40 via-transparent to-secondary-950/40" />

      <div className="relative z-10 w-full mx-auto max-w-content px-4 md:px-8 py-28 md:py-36">
        <div className="max-w-3xl">
          <p className="animate-fade-up inline-flex items-center gap-2 text-xs md:text-sm text-background-100 font-label border border-background-100/40 rounded-full px-3 py-1.5">
            <span className="w-2 h-2 rounded-full bg-primary-400 animate-live-dot" />
            每周更新 · 现场素材完整收录
          </p>
          <h1 className="animate-fade-up anim-delay-1 mt-6 font-heading text-3xl md:text-5xl lg:text-[56px] font-black leading-tight text-background-50">
            反差现场：台上台下两副面孔，
            <br className="hidden md:block" />
            网红反差真实性格尽收眼底
          </h1>
          <p className="animate-fade-up anim-delay-2 mt-6 text-sm md:text-lg leading-relaxed text-background-100/90 max-w-2xl">
            对准镜头前后的反差，把直播录制、台下偶遇、粉丝爆料与私下被拍的画面集中呈现。
            不想只听口中说辞，就直接看现场的影子——台上营业状态与私下真实性格，放在一起对比。
          </p>
          <div className="animate-fade-up anim-delay-3 mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/category/live"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3.5 rounded-md text-sm font-label transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-lg leading-none" aria-hidden="true" />
              进入反差现场
            </Link>
            <Link
              to="/category/fanleak"
              className="inline-flex items-center justify-center gap-2 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-100/40 px-6 py-3.5 rounded-md text-sm font-label transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              <i className="ri-chat-private-line text-lg leading-none" aria-hidden="true" />
              翻阅粉丝爆料
            </Link>
          </div>
        </div>

        {leader && (
          <div className="animate-fade-up anim-delay-4 mt-12 md:mt-16 max-w-3xl rounded-lg overflow-hidden border border-background-100/20 bg-black/35 backdrop-blur-sm">
            <div className="grid grid-cols-1 md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-background-100/15">
              <div className="p-4 md:p-5">
                <p className="text-[11px] tracking-[0.25em] text-accent-300 font-label mb-2">台上 / 镜头前</p>
                <p className="text-sm text-background-100/90 leading-relaxed">{leader.onstage}</p>
              </div>
              <div className="p-4 md:p-5">
                <p className="text-[11px] tracking-[0.25em] text-secondary-200 font-label mb-2">台下 / 镜头外</p>
                <p className="text-sm text-background-100/90 leading-relaxed">{leader.offstage}</p>
              </div>
            </div>
            <Link
              to={`/article/${leader.slug}`}
              className="flex items-center justify-between gap-3 px-4 md:px-5 py-3 bg-primary-500/90 hover:bg-primary-500 transition-colors"
            >
              <span className="text-xs md:text-sm text-background-50 line-clamp-1">
                本周焦点：{leader.title}
              </span>
              <i className="ri-arrow-right-line text-background-50 shrink-0" aria-hidden="true" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}